import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { api, formatApiError } from "../lib/api";
import { tr } from "../lib/i18n";
import SuggestionCard from "../components/SuggestionCard";
import { EditDialog, ScheduleDialog } from "../components/SuggestionDialogs";

const TABS = ["pending", "scheduled", "posted", "skipped"];

export default function SocialSuggestionsPage() {
  const [tab, setTab] = useState("pending");
  const [data, setData] = useState(null);
  const [editing, setEditing] = useState(null);
  const [scheduling, setScheduling] = useState(null);

  const load = useCallback(async () => {
    try { const { data: d } = await api.get("/social/suggestions", { params: { status: tab } }); setData(d); } catch (e) { toast.error(formatApiError(e)); }
  }, [tab]);
  useEffect(() => { load(); }, [load]);

  const changed = (doc) => {
    if (doc.status !== tab) { load(); return; }
    setData((d) => ({ ...d, items: d.items.map((x) => (x.id === doc.id ? doc : x)) }));
  };

  return (
    <div data-testid="social-suggestions-page" className="max-w-5xl">
      <div className="kicker">{tr("x.social_media")}</div>
      <h1 className="mt-2" style={{ fontSize: 30, fontWeight: 600 }}>{tr("sg.title")}</h1>
      <p className="text-sm text-[var(--gray-400)] mt-2 max-w-2xl">{tr("sg.intro")}</p>
      <p className="text-xs mt-2 text-amber-700" data-testid="sg-mock-note">{tr("sg.mock_note")}</p>
      <div className="flex gap-1 mt-5 mb-4 overflow-x-auto border-b border-[var(--line)]" role="tablist">
        {TABS.map((k) => (
          <button key={k} role="tab" aria-selected={tab === k} onClick={() => setTab(k)} data-testid={`sg-tab-${k}`}
            className={`px-3 py-2 text-sm font-semibold whitespace-nowrap border-b-2 -mb-px transition-colors ${tab === k ? "border-[var(--accent,#c8102e)] text-[var(--ink)]" : "border-transparent text-[var(--gray-400)]"}`}>
            {tr(`sg.tab_${k /* i18n-keys: pending,scheduled,posted,skipped */}`)} <span className="text-xs opacity-70" data-testid={`sg-count-${k}`}>{data?.counts?.[k] ?? ""}</span>
          </button>
        ))}
      </div>
      {!data ? <div className="panel p-5 text-sm">{tr("x.loading")}</div>
        : data.items.length === 0 ? <div className="panel p-6 text-sm text-[var(--gray-400)]" data-testid="sg-empty">{tab === "pending" ? tr("sg.empty_pending") : tr("sg.empty_other")}</div>
        : <div className="space-y-4">
            {data.items.length > 0 && data.items.every((s) => s.source !== "ai") && <div className="text-xs opacity-75" data-testid="sg-ai-hint">{tr("sg.ai_hint")}</div>}
            {data.items.map((s) => <SuggestionCard key={s.id} s={s} onChanged={changed} onEdit={setEditing} onSchedule={setScheduling} />)}</div>}
      <EditDialog s={editing} onClose={() => setEditing(null)} onDone={(d) => { setEditing(null); changed(d); }} />
      <ScheduleDialog s={scheduling} onClose={() => setScheduling(null)} onDone={(d) => { setScheduling(null); changed(d); }} />
    </div>
  );
}
